import { useEffect, useState } from 'react';
import { useRevealOnScroll } from '@/hooks/useScrollReveal';
import { Link } from 'react-router-dom';

const services = [
  {
    id: 'ekspres',
    icon: 'ri-flight-takeoff-line',
    title: 'Ekspres Kurye Servisi',
    sub: '24–72 Saat Teslimat',
    badge: 'En Popüler',
    desc: 'Kapıdan kapıya ekspres teslimat hizmeti. DHL, FedEx, UPS ve TNT entegrasyonuyla 220\'yi aşkın ülkeye en hızlı ve en avantajlı fiyatlarla gönderi yapıyoruz.',
    features: ['Kapıdan kapıya teslimat', 'Anlık kargo takibi', 'Sigortalı taşıma', 'Gümrük müşavirliği', 'Hafta sonu teslimat', '220+ ülke kapsamı'],
    img: 'https://readdy.ai/api/search-image?query=professional%20courier%20delivery%20person%20handing%20package%20at%20door%20orange%20uniform%20logistics%20express%20delivery%20service%20cinematic%20photography%20dark%20background&width=800&height=450&seq=svc-ekspres-v3&orientation=landscape',
  },
  {
    id: 'eticaret',
    icon: 'ri-store-2-line',
    title: 'Uluslararası E-Ticaret Servisi',
    sub: 'Marketplace Entegrasyonu',
    badge: undefined,
    desc: 'Amazon, Etsy, eBay ve diğer marketplace\'lere otomatik entegrasyon. Sipariş geldiği anda işleme alınır, stok yönetimi ve iade süreçleri otomatikleşir. E-ihracatınızı kolaylaştırıyoruz.',
    features: ['Amazon FBA desteği', 'Etsy & eBay entegrasyonu', 'Otomatik gümrük beyanı', 'İade yönetimi', 'Stok takip sistemi', 'Çoklu kanal yönetimi'],
    img: 'https://readdy.ai/api/search-image?query=ecommerce%20online%20shopping%20packages%20boxes%20warehouse%20conveyor%20belt%20orange%20lighting%20modern%20logistics%20professional%20photography%20wide%20angle&width=800&height=450&seq=svc-eticaret-v3&orientation=landscape',
  },
  {
    id: 'kargo',
    icon: 'ri-ship-line',
    title: 'Uluslararası Kargo Taşımacılığı',
    sub: 'Hava, Deniz, Kara',
    badge: undefined,
    desc: 'FCL/LCL konteyner, hava charter ve TIR hizmetleriyle 220+ ülkeye yük taşımacılığı. Her boyut ve ağırlık için uygun çözüm. Tehlikeli madde ve soğuk zincir taşımacılığı da yapıyoruz.',
    features: ['FCL / LCL konteyner', 'Hava charter hizmetleri', 'TIR ve karayolu', 'Ağır ve hacimli yük', 'Tehlikeli madde taşıma', 'Soğuk zincir lojistik'],
    img: 'https://readdy.ai/api/search-image?query=cargo%20ship%20container%20vessel%20at%20port%20sunset%20orange%20sky%20maritime%20logistics%20professional%20photography%20cinematic%20wide%20angle&width=800&height=450&seq=svc-kargo-v3&orientation=landscape',
  },
  {
    id: 'fulfillment',
    icon: 'ri-archive-2-line',
    title: 'Fulfillment',
    sub: '5.000 m² Depo – Esenyurt/İstanbul',
    badge: undefined,
    desc: 'İstanbul Esenyurt\'ta 5.000 m² iklim kontrollü depomuzda stoklama, paketleme, fotoğrafçılık ve otomatik sipariş kargolama hizmeti. Ürünleriniz güvende, siparişleriniz zamanında.',
    features: ['5.000 m² depo alanı', 'Ürün fotoğrafçılığı', 'Kişiselleştirilmiş paket', 'Otomatik kargolama', 'İade merkezi', 'İklim kontrollü ortam'],
    img: 'https://readdy.ai/api/search-image?query=modern%20fulfillment%20warehouse%20workers%20packing%20boxes%20conveyor%20belt%20orange%20accent%20lighting%20professional%20wide%20angle%20photography%20logistics%20center&width=800&height=450&seq=svc-fulfillment-v3&orientation=landscape',
  },
  {
    id: 'online-magaza',
    icon: 'ri-shopping-bag-line',
    title: 'Online Mağaza',
    sub: 'E-Ticaret Altyapısı',
    badge: undefined,
    desc: 'Kendi online mağazanızı kurun, ürünlerinizi dünyaya satın. CargoNet\'in lojistik altyapısıyla entegre çalışan e-ticaret çözümleri. Mağaza kurulumundan kargoya kadar her şey tek elden.',
    features: ['Mağaza kurulum desteği', 'Ödeme entegrasyonu', 'Ürün yönetimi', 'Sipariş takibi', 'Lojistik entegrasyonu', 'Teknik destek'],
    img: 'https://readdy.ai/api/search-image?query=online%20store%20ecommerce%20website%20laptop%20shopping%20cart%20products%20dark%20background%20orange%20accent%20lighting%20professional%20business%20photography&width=800&height=450&seq=svc-magaza-v3&orientation=landscape',
  },
  {
    id: 'mikro',
    icon: 'ri-global-line',
    title: 'Mikro İhracat – ETGB',
    sub: 'Kolay Gümrük',
    badge: undefined,
    desc: '300 EUR\'ya kadar gümrüksüz ihracat imkânı. Elektronik Ticaret Gümrük Beyannamesi (ETGB) ile hızlı ve kolay ihracat. Tüm ürün kategorilerinde geçerli, uzman gümrük desteği dahil.',
    features: ['300 EUR gümrük muafiyeti', 'ETGB elektronik beyanname', 'Hızlı gümrük onayı', 'Tüm ürün kategorileri', 'Uzman gümrük desteği', 'Online başvuru'],
    img: 'https://readdy.ai/api/search-image?query=customs%20clearance%20export%20import%20documents%20world%20map%20global%20trade%20professional%20office%20orange%20accent%20lighting%20business%20photography&width=800&height=450&seq=svc-mikro-v3&orientation=landscape',
  },
  {
    id: 'atr',
    icon: 'ri-file-text-line',
    title: 'A.TR Belgesi',
    sub: 'AB Ticareti – Gümrük Muafiyeti',
    badge: undefined,
    desc: 'Avrupa Birliği ülkelerine ihracatta gümrük vergisi muafiyeti sağlayan A.TR dolaşım belgesi hazırlama hizmeti. 24 saat içinde hazır, tüm AB ülkelerinde geçerli.',
    features: ['24 saat hazırlık süresi', 'Online e-başvuru', 'Tüm AB ülkeleri geçerli', 'Gümrük uzman desteği', 'Dijital arşivleme', 'Hızlı onay süreci'],
    img: 'https://readdy.ai/api/search-image?query=European%20Union%20customs%20document%20official%20certificate%20trade%20professional%20office%20desk%20orange%20accent%20lighting%20business%20photography&width=800&height=450&seq=svc-atr-v3&orientation=landscape',
  },
  {
    id: 'onboard',
    icon: 'ri-user-star-line',
    title: 'On Board Kurye Servisi',
    sub: 'VIP Teslimat',
    badge: 'VIP',
    desc: 'Acil ve yüksek değerli kargolar için özel kurye hizmeti. Kurye yükünüzle birlikte uçuşa biner, doğrudan alıcıya teslim eder. 7/24 hizmet, tam gizlilik garantisi.',
    features: ['Aynı gün teslimat', 'Kapıdan kapıya VIP', 'Yüksek değerli kargo', '7/24 hizmet', 'Gizlilik garantisi', 'Özel sigorta'],
    img: 'https://readdy.ai/api/search-image?query=VIP%20business%20courier%20at%20airport%20terminal%20premium%20service%20briefcase%20suit%20dramatic%20lighting%20cinematic%20professional%20photography%20dark%20background&width=800&height=450&seq=svc-onboard-v3&orientation=landscape',
  },
  {
    id: 'sigorta',
    icon: 'ri-shield-check-line',
    title: 'Sigorta',
    sub: 'Tam Güvence',
    badge: undefined,
    desc: 'Tüm sevkiyatlarınız sigorta kapsamında. Hasar veya kayıp durumunda eksiksiz tazminat. Aynı gün poliçe onayı, global kapsam. Müşterilerimizin mallarını sadece taşımıyoruz, daha ileriye götürüyoruz.',
    features: ['Tam hasar kapsama', 'Hızlı tazminat süreci', 'Online poliçe düzenleme', 'Aynı gün onay', 'Global kapsam', 'Tüm kargo türleri'],
    img: 'https://readdy.ai/api/search-image?query=cargo%20insurance%20protection%20shield%20packages%20secured%20warehouse%20professional%20photography%20orange%20warm%20lighting%20business%20dark%20background&width=800&height=450&seq=svc-sigorta-v3&orientation=landscape',
  },
];

const steps = [
  { n: '01', icon: 'ri-phone-line', t: 'İletişim', d: 'Bizimle iletişime geçin, ihtiyaçlarınızı ve kargo detaylarınızı paylaşın.' },
  { n: '02', icon: 'ri-file-text-line', t: 'Teklif', d: '24 saat içinde size özel, rekabetçi fiyat teklifi hazırlıyoruz.' },
  { n: '03', icon: 'ri-truck-line', t: 'Gönderi', d: 'Yükünüzü kapınızdan teslim alıyoruz, süreç başlıyor.' },
  { n: '04', icon: 'ri-map-pin-2-line', t: 'Teslimat', d: 'Anlık takip sistemiyle izleyin, alıcı kapısında teslim.' },
];

export default function ServicesPage() {
  useRevealOnScroll();
  const [active, setActive] = useState('ekspres');
  useEffect(() => {
    document.title = 'Hizmetler | CargoNet – Uluslararası Lojistik Çözümleri';
    window.scrollTo(0, 0);
  }, []);
  const cur = services.find((s) => s.id === active) || services[0];

  return (
    <main style={{ background: 'var(--bg)', color: 'var(--text1)' }}>

      {/* ── HERO ── */}
      <section className="relative pt-36 pb-24 overflow-hidden" style={{ background: 'var(--bg)' }}>
        <div className="absolute inset-0 pointer-events-none">
          <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(var(--dot-color) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
          <div style={{ position: 'absolute', top: '-200px', right: '-150px', width: 600, height: 600, background: 'radial-gradient(circle, var(--glow2) 0%, transparent 65%)', borderRadius: '50%' }} />
          <div style={{ position: 'absolute', bottom: 0, left: '-20%', right: '-20%', height: '40%', backgroundImage: 'linear-gradient(var(--grid-color) 1px, transparent 1px), linear-gradient(90deg, var(--grid-color) 1px, transparent 1px)', backgroundSize: '50px 50px', transform: 'perspective(600px) rotateX(62deg)', transformOrigin: 'bottom', maskImage: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 80%)', WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 80%)' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <div className="label inline-flex"><div className="label-dot" />Hizmetlerimiz ve Çözümlerimiz</div>
          <h1
            className="h-font leading-[1.0] mb-6"
            style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(42px,5.5vw,76px)', color: 'var(--text1)' }}
          >
            Her İhtiyacınız<br /><span className="text-gradient">Tek Çatı Altında</span>
          </h1>
          <p style={{ fontSize: 18, color: 'var(--text2)', maxWidth: 560, margin: '0 auto 36px', lineHeight: 1.75 }}>
            9 hizmet kategorisiyle uçtan uca lojistik çözümler. Ekspres kurye&apos;den fulfillment&apos;a, mikro ihracattan A.TR belgesine kadar her şey burada.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/iletisim" className="btn-primary cursor-pointer">
              Ücretsiz Teklif Al <i className="ri-arrow-right-line bounce-x" />
            </Link>
            <a href="tel:+908502420822" rel="nofollow" className="btn-ghost cursor-pointer">
              <i className="ri-phone-line" /> 0850 242 0 822
            </a>
          </div>
        </div>
      </section>

      {/* ── SERVICES TABS ── */}
      <section style={{ background: 'var(--bg2)', padding: '80px 0', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

            {/* Sidebar list */}
            <div className="space-y-1">
              {services.map((svc) => (
                <button
                  key={svc.id}
                  onClick={() => setActive(svc.id)}
                  className="w-full flex items-center gap-3 p-3.5 rounded-2xl text-left cursor-pointer transition-all duration-300"
                  style={{
                    background: active === svc.id ? 'rgba(232,97,26,0.1)' : 'var(--surface)',
                    border: `1px solid ${active === svc.id ? 'rgba(232,97,26,0.35)' : 'var(--border)'}`,
                  }}
                >
                  <div
                    className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0"
                    style={{ background: active === svc.id ? '#E8611A' : 'var(--surface2)' }}
                  >
                    <i
                      className={svc.icon}
                      style={{ color: active === svc.id ? '#fff' : 'var(--text3)', fontSize: 15 }}
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div
                      style={{
                        fontWeight: 700, fontSize: 13,
                        color: active === svc.id ? 'var(--text1)' : 'var(--text2)',
                        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                      }}
                    >
                      {svc.title}
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 1 }}>{svc.sub}</div>
                  </div>
                  {svc.badge && <span className="tag-sm flex-shrink-0" style={{ fontSize: 10 }}>{svc.badge}</span>}
                </button>
              ))}
            </div>

            {/* Detail panel */}
            <div className="lg:col-span-2">
              <div className="relative rounded-3xl overflow-hidden grad-border mb-6" style={{ height: 300 }}>
                <img
                  src={cur.img}
                  alt={cur.title}
                  className="w-full h-full object-cover transition-all duration-500"
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, var(--overlay-dark) 0%, transparent 50%)' }} />
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: 'linear-gradient(90deg, transparent, rgba(232,97,26,0.6), transparent)', animation: 'scan 3s linear infinite' }} />
              </div>

              <div className="flex items-start gap-4 mb-4">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-2xl flex-shrink-0"
                  style={{ background: '#E8611A', boxShadow: '0 0 24px rgba(232,97,26,0.4)' }}
                >
                  <i className={`${cur.icon} text-white text-lg`} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 flex-wrap">
                    <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 22, color: 'var(--text1)' }}>{cur.title}</div>
                    {cur.badge && <span className="tag-sm">{cur.badge}</span>}
                  </div>
                  <div style={{ color: 'var(--orange)', fontWeight: 700, fontSize: 13, marginTop: 2 }}>{cur.sub}</div>
                </div>
              </div>

              <p style={{ fontSize: 15, color: 'var(--text2)', lineHeight: 1.8, marginBottom: 24 }}>{cur.desc}</p>

              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-8">
                {cur.features.map((f, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-2 px-3 py-2.5 rounded-xl"
                    style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
                  >
                    <div className="w-4 h-4 flex items-center justify-center rounded-full bg-[#E8611A] flex-shrink-0">
                      <i className="ri-check-line text-white" style={{ fontSize: 9 }} />
                    </div>
                    <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text2)' }}>{f}</span>
                  </div>
                ))}
              </div>

              <Link to="/iletisim" className="btn-primary cursor-pointer">
                Bu Hizmet İçin Teklif Al <i className="ri-arrow-right-line bounce-x" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── PROCESS ── */}
      <section style={{ background: 'var(--bg)', padding: '96px 0', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center max-w-xl mx-auto mb-16">
            <div className="label inline-flex"><div className="label-dot" />Nasıl Çalışır</div>
            <h2
              className="reveal h-font leading-[1.1]"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px,4.5vw,52px)', color: 'var(--text1)' }}
            >
              4 Adımda <span className="text-gradient">Süreç</span>
            </h2>
            <p className="reveal d2 mt-4" style={{ fontSize: 16, color: 'var(--text2)', lineHeight: 1.7 }}>
              Basit, şeffaf ve hızlı. İlk iletişimden teslimatına kadar her adımı sizinle birlikte yönetiyoruz.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {steps.map((s, i) => (
              <div key={i} className={`reveal d${i + 1} card-dark p-8 relative overflow-hidden`}>
                <div
                  style={{
                    position: 'absolute', top: -8, right: 12,
                    fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 72,
                    color: 'var(--orange)', opacity: 0.07, lineHeight: 1, userSelect: 'none',
                  }}
                >
                  {s.n}
                </div>
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-2xl mb-5"
                  style={{ background: '#E8611A', boxShadow: '0 0 20px rgba(232,97,26,0.3)' }}
                >
                  <i className={`${s.icon} text-white text-lg`} />
                </div>
                <h3 style={{ fontWeight: 800, fontSize: 17, color: 'var(--text1)', marginBottom: 8 }}>{s.t}</h3>
                <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.7 }}>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ background: 'var(--bg2)', padding: '80px 20px', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div
            className="rounded-3xl p-12 text-center relative overflow-hidden"
            style={{ background: 'var(--surface)', border: '1px solid var(--border2)' }}
          >
            <div style={{ position: 'absolute', top: '-100px', left: '50%', transform: 'translateX(-50%)', width: 400, height: 400, background: 'radial-gradient(circle, var(--glow2) 0%, transparent 65%)', borderRadius: '50%', pointerEvents: 'none' }} />
            <div className="relative">
              <h2 style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(28px,4vw,48px)', color: 'var(--text1)', marginBottom: 16 }}>
                Hangi hizmete ihtiyacınız var?
              </h2>
              <p style={{ fontSize: 17, color: 'var(--text2)', maxWidth: 480, margin: '0 auto 36px', lineHeight: 1.7 }}>
                Uzman ekibimiz size en uygun çözümü bulmak için hazır. Ücretsiz danışmanlık alın.
              </p>
              <div className="flex flex-wrap gap-3 justify-center">
                <Link to="/iletisim" className="btn-primary cursor-pointer">
                  Ücretsiz Danışmanlık <i className="ri-arrow-right-line bounce-x" />
                </Link>
                <a href="tel:+908502420622" rel="nofollow" className="btn-ghost cursor-pointer">
                  <i className="ri-phone-line" /> Hemen Ara
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
